import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Garante que cada navegação começa no topo da página (comportamento padrão do Next.js). */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
